var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavouriteAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "add-to-favourite-b",
    d: "M14.5,26 L12.5425,24.2016349 C5.59,17.8392371 1,13.6430518 1,8.49318801 C1,4.29700272 4.267,1 8.425,1 C10.774,1 13.0285,2.10354223 14.5,3.84741144 C15.9715,2.10354223 18.226,1 20.575,1 C24.733,1 28,4.29700272 28,8.49318801 C28,13.6430518 23.41,17.8392371 16.4575,24.2152589 L14.5,26 Z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "add-to-favourite-a",
    width: "125.9%",
    height: "128%",
    x: "-13%",
    y: "-14%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.140461101 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    filter: "url(#add-to-favourite-a)",
    xlinkHref: "#add-to-favourite-b"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "square",
    strokeWidth: 1.5,
    d: "M20.575,1.75 C22.4431994,1.75 24.1125645,2.4884546 25.3140014,3.70092506 C26.5178854,4.91586497 27.25,6.60428344 27.25,8.49318801 C27.25,13.4809206 22.6823875,17.4889136 16.0054455,23.6121973 L16.0054455,23.6121973 L14.5018859,24.9832731 L13.0488293,23.6483441 C6.33394727,17.5033995 1.75,13.4899215 1.75,8.49318801 C1.75,6.60428344 2.4821146,4.91586497 3.68599855,3.70092506 C4.88743554,2.4884546 6.55680057,1.75 8.425,1.75 C10.5530515,1.75 12.5941412,2.75175772 13.9267993,4.33108584 C14.1351084,4.57795225 14.3265952,4.83950748 14.5001413,5.11281881 C14.6735543,4.83930322 14.8649729,4.57785586 15.0732007,4.33108584 C16.4058588,2.75175772 18.4469485,1.75 20.575,1.75 L20.575,1.75 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteAdd);
export default __webpack_public_path__ + "static/media/favourite-add.c8f01e40.svg";
export { ForwardRef as ReactComponent };